<div *ngFor="let section of sectionsmenu" class="inm-expandable__container">
  <a *ngIf="!section.subSection && checkValidLink(section.feature)"
    routerLinkActive="active" class="inm-expandable__title" [routerLink]="section.path"
    [routerLinkActiveOptions]="{ exact: false }">{{ section.name }}</a>
</div>
